import Map from "./components/Map";
import { outlineWatcher } from "./utilities/a11y";
import { Footer } from "./components/Footer";
import { Picker } from "./components/Picker";
import ModalController from "./components/ModalController";
import DialogController from "./components/DialogController";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    outlineWatcher();
  }, []);

  return (
    <div className="App">
      <Map />
      <Footer />
      <Picker />

      <ModalController />
      <DialogController />
    </div>
  );
}

export default App;
